module.exports = __webpack_public_path__ + "static/media/BreathAwareness5.53083887.m4a";